<template>
    <div class="flex-fill flex-column no-scroll">
        <fe-crud
            ref="crud"
            :autoload="false"
            :config="$models.unknownSchool"
            :readParams="{ upload_id: $props.uploadId }"
            @read="v => items = v"
        />

        <fe-mask v-show="loading" :showLoader="true" />

        <fe-dialog
            width="400"
            title="Set School Alias"
            v-if="dialog.show"
            @dismiss="dialog.show=false"
            @close="dialog.show=false"
            @accept="setAlias"
            acceptButtonText="Alias"
            :acceptButtonDisabled="!dialog.record"
            persistent
        >
            <v-form>
                <fe-label>School</fe-label>
                <v-autocomplete
                    :items="schools"
                    v-model="dialog.record"
                    itemValue="id"
                    itemText="name"
                    required
                    flat solo dense
                />
            </v-form>
        </fe-dialog>

        <fe-grid
            :columnDefs="columns"
            :rowData="items"
            class="flex-grow-1"
            displayDensity="small"
            ref="grid"
            :showAddRowBtn="false"
            @selectionChanged="selectRow"
            @cellValueChanged="sanitize"
            showToolbar
        >
            <template v-slot:toolbar-items>
                <fe-btn usage="primary" v-if="canSave" @click="doSave">Save</fe-btn>

                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <fe-btn usage="primary" v-on="on" :disabled="!selections.length">
                            Actions
                        </fe-btn>
                    </template>

                    <v-list>
                        <v-list-item v-for="(item, index) in tools" :key="index" @click="item.handler()">
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </fe-grid>
    </div>
</template>

<script>
    export default {
        name: 'UnknownSchools',
        props: {
            uploadId: {
                required: true
            }
        },
        data() {
            let me = this

            return {
                loading: false,
                exclusive: ['new_school', 'exclude_flag', 'school_alias', 'ignore_flag'],
                canSave: false,
                selections: [],
                schools: [],
                items: [],
                dialog: {
                    show: false,
                    record: null
                },
                pendingText: '<br><p class="caption mt-2">This will also save any pending changes.</p>',
                originalItems: [],
                tools: [{
                    title: 'Create School',
                    description: 'Create this as a school in eduCLIMBER',
                    handler() {
                        me.ensureExclusive('new_school', me.selections, true)
                        me.$messageBox({
                            title: 'Confirm Create',
                            persistent: true,
                            maxWidth: 600,
                            message: 'Are you sure you want to create ' + me.selections.length + ' record(s) as a new school? ' +
                                me.pendingText,
                            actions: [{
                                text: 'Cancel', primary: false
                            }, {
                                text: 'Ok', primary: true,
                                onClick: () => {
                                    me.doSave()
                                }
                            }]
                        })
                    }
                }, {
                    title: 'Exclude School',
                    description: 'Exclude records that have this school from being processed in eduCLIMBER',
                    handler() {
                        me.ensureExclusive('exclude_flag', me.selections, true)
                        me.$messageBox({
                            title: 'Confirm Exclude',
                            persistent: true,
                            maxWidth: 600,
                            message: 'Are you sure you want to exclude ' + me.selections.length + ' school(s)? ' +
                                me.pendingText,
                            actions: [{
                                text: 'Cancel', primary: false
                            }, {
                                text: 'Ok', primary: true,
                                onClick: () => {
                                    me.doSave()
                                }
                            }]
                        })
                    }
                }, {
                    title: 'Ignore School',
                    description: 'Process the record on the file, but ignore the school during processing',
                    handler() {
                        me.ensureExclusive('ignore_flag', me.selections, true, true)
                        me.$messageBox({
                            title: 'Confirm Ingore',
                            persistent: true,
                            maxWidth: 600,
                            message: 'Are you sure you want to ignore ' + me.selections.length + ' school(s)? ' +
                                me.pendingText,
                            actions: [{
                                text: 'Cancel', primary: false
                            }, {
                                text: 'Ok', primary: true,
                                onClick: () => {
                                    me.doSave()
                                }
                            }]
                        })
                    }
                }, {
                    title: 'Alias to School',
                    description: 'Set this school name as another known name for a different school on all imports',
                    handler() {
                        me.dialog.show = true
                    }
                }],
                columns: []
            }
        },
        watch: {
            items(v) {
            }
        },
        mounted() {
            this.loadSchools()
        },
        methods: {
            doSave() {
                let dirty = this.$isDirty(this.originalItems, this.items)
                this.loading = true
                this.$refs.crud.update(dirty)
                    .then(response => {
                        this.loadSchools()
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            setAlias() {
                this.dialog.show = false
                let me = this
                this.ensureExclusive('school_alias', this.selections, me.dialog.record)
                this.sanitize()
                this.$refs.grid.gridApi.deselectAll()
                this.doSave()
            },
            selectRow(row) {
                this.selections = this.$refs.grid.gridApi.getSelectedRows()
            },
            ensureExclusive(key, data, value) {
                data.forEach(rec => {
                    if (value) rec[key] = value

                    this.exclusive.forEach(other => {
                        if (key != other) {
                            rec[other] = ''
                        }
                    })
                })
                this.sanitize()
            },
            sanitize() {
                let keys = this.exclusive
                // this function will make sure only one of the exclusive values is set per row
                this.items.forEach(rec => {
                    keys.forEach(k => {
                        if (rec[k]) {
                            keys.forEach(o => {
                                if (o != k) {
                                    rec[o] = undefined
                                }
                            })
                        }
                    })
                })

                // this will check to see if the original fetched data set has been manipulated
                let dirty = this.$isDirty(this.originalItems, this.items)
                if (dirty) {
                    this.canSave = true
                } else {
                    this.canSave = false
                }
                // Since we are changing cells behind the ag-grid api, call refresh
                this.$refs.grid.gridApi.refreshCells()
            },
            loadSchools() {
                let me = this
                let id = this.$props.uploadId
                this.originalItems = []
                this.items = []

                this.loading = true
                this.$modelGet('school')
                    .then(response => {
                        this.schools = response

                        this.columns = [me.$grid.checkColumn(), {
                            headerName: 'Import School Name',
                            field: 'name',
                            sortable: true,
                            flex: 1
                        }, {
                            headerName: 'Alias To',
                            field: 'school_alias',
                            editable: true,
                            flex: 1,
                            tooltipValueGetter: (param) => 'This school will also be known as the selected school in eduCLIMBER',
                            cellRenderer: v => {
                                if (v.value) {
                                    let r = me.schools.find(rec => { return rec.id == v.value })
                                    if (r) return r.name
                                }
                                return ''
                            },
                            cellEditorFramework: "FeGridChipSelect",
                            cellEditorParams: {
                                rowDataKey: "school_alias",
                                mode: "edit",
                                items: me.$data.schools,
                                keyProp: "id",
                                labelProp: "name",
                                disableChips: true
                            }
                        }]
                        this.$refs.crud.read()
                            .then(() => {
                                this.items.forEach(rec => {
                                    rec.new_school   = undefined
                                    rec.school_alias = undefined
                                    rec.exclude_flag = undefined
                                    rec.ignore_flag  = undefined
                                })
                                this.originalItems = this.$_.cloneDeep(this.items)
                                this.$emit('count', this.originalItems.length)
                            })
                            .finally(() => {
                                this.loading = false
                                this.sanitize()
                            })
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
